export default class SwiperProgress {
    // @TODO reverse progress direction
    el;
    progress;
    progressDuration;
    progressId;
    ts;
    direction;
    constructor(el) {
        this.el = el;
        this.progress = 0;
        this.progressDuration = 2000;
        this.ts = new Date().getTime();
        this.direction = true;
        this.build();
    }
    build() {
        const length = 52, stroke = 1, circum = (length - stroke) * 2;
        let circumProgress = circum * this.progress;
        if (!this.direction) {
            circumProgress = 0;
        }
        const progress = this.el.querySelector('.swiper-slide-progress-path');
        if (progress) {
            progress.style.width = circumProgress + '%';
        }
    }
    update(newProgress) {
        this.progress = Math.min(1, Math.max(0, newProgress));
        this.build();
    }
    progressStart(duration, direction) {
        this.progressDuration = duration;
        this.direction = direction;
        this.update((this.direction) ? 0 : 1);
        this.ts = new Date().getTime();
        if (this.progressId)
            clearInterval(this.progressId);
        this.progressId = setInterval(() => {
            this.progressUpdate();
        }, 100);
    }
    progressStop() {
        if (this.progressId)
            clearInterval(this.progressId);
        this.update((this.direction) ? 1 : 0);
    }
    progressUpdate() {
        const newTS = new Date().getTime(), newTime = (this.direction) ? (newTS - this.ts) : (this.progressDuration - newTS + this.ts), newProgress = newTime / this.progressDuration;
        this.update(newProgress);
        if (newProgress < 0 || newProgress > 1) {
            this.progressStop();
        }
    }
}
